import ResourceEn from "./Resource.en";
import ResourceFr from "./Resource.fr";

export default {
    "en-US": ResourceEn,
    "fr-CA": ResourceFr
};